import React, {Component} from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {saveDesign} from "../../AC/save-design";
import Mediator from "../../services/Mediator";

export class KeyObserver extends Component {
  static propTypes = {
    saveDesign: PropTypes.func
  };
  componentDidMount() {
    if (document) {
      document.addEventListener(`keypress`, this.onKeyDownPress);
      document.addEventListener(`keydown`, this.onKeyDownPress);
    }
  }
  componentWillUnmount() {
    if (document) {
      document.removeEventListener(`keypress`, this.onKeyDownPress);
      document.removeEventListener(`keydown`, this.onKeyDownPress);
    }
  }
  keyCodes = {
    ArrowRight: 39,
    ArrowLeft: 37,
    ArrowUp: 38,
    ArrowDown: 40,
    V: 86,
    v: 118,
    C: 67,
    c: 99,
    A: 65,
    a: 97,
    Z: 90,
    z: 122,
    S: 83,
    s: 115,
    Delete: 46,
    Backspace: 8,
    RightSquareBracket: 221,
    LeftSquareBracket: 219
  };
  onKeyDownPress = (e) => {
    const {key, metaKey, ctrlKey, shiftKey, altKey, keyCode, target} = e;
    if (key && target.tagName === `BODY`) {
      const delta = shiftKey ? 10 : 1;
      switch (keyCode) {
        case this.keyCodes[`ArrowRight`]:
          Mediator.moveActiveObjectTo(`right`, delta);
          e.preventDefault();
          break;
        case this.keyCodes[`ArrowLeft`]:
          Mediator.moveActiveObjectTo(`left`, delta);
          e.preventDefault();
          break;
        case this.keyCodes[`ArrowUp`]:
          Mediator.moveActiveObjectTo(`top`, delta);
          e.preventDefault();
          break;
        case this.keyCodes[`ArrowDown`]:
          Mediator.moveActiveObjectTo(`down`, delta);
          e.preventDefault();
          break;
        case this.keyCodes[`z`]:
        case this.keyCodes[`Z`]:
          if (metaKey || ctrlKey) {
            if (e.shiftKey) {
              Mediator.redo();
            } else {
              Mediator.undo();
            }
          }
          break;
        case this.keyCodes[`s`]:
        case this.keyCodes[`S`]:
          if (metaKey || ctrlKey) {
            e.preventDefault();
            this.props.saveDesign();
          }
          break;

        case this.keyCodes[`Delete`]:
        case this.keyCodes[`Backspace`]:
          Mediator.removeActive();
          break;

        case this.keyCodes[`c`]:
        case this.keyCodes[`C`]:
          if (metaKey || ctrlKey) {
            Mediator.copyActiveObject();
          }
          break;

        case this.keyCodes[`v`]:
        case this.keyCodes[`V`]:
          if (metaKey || ctrlKey) {
            Mediator.pasteCopiedObject();
          }
          break;

        case this.keyCodes[`a`]:
        case this.keyCodes[`A`]:
          if (metaKey || ctrlKey) {
            e.preventDefault();
            Mediator.selectAllObjects();
          }
          break;

        case this.keyCodes[`RightSquareBracket`]:
          e.preventDefault();
          if (altKey) {
            Mediator.bringActiveToFront();
          } else {
            Mediator.bringActiveToForward();
          }
          break;

        case this.keyCodes[`LeftSquareBracket`]:
          e.preventDefault();
          if (altKey) {
            Mediator.sendActiveToBack();
          } else {
            Mediator.sendActiveToBackwards();
          }
          break;
      }
    }
  };
  render() {
    return <div />;
  }
}

const mapDispatchToProps = {
  saveDesign
};

export default connect(null, mapDispatchToProps)(KeyObserver);
